import { createAsyncThunk } from '@reduxjs/toolkit';
import UserService from '../../services/user.service';
import { ClinicLocationProviderService } from '../../services/clinic-location-provider.service';

const userInfo = createAsyncThunk(
  'user/userInfo',
  async (_, { rejectWithValue }) => {
    try {
      return await UserService.getUserInfo();
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const updateOwnUserInfo = createAsyncThunk(
  'user/updateOwnUserInfo',
  async (updatedProperties: any, { rejectWithValue }) => {
    try {
      return await UserService.updateOwnUserInfo(updatedProperties);
    } catch (error) {
      rejectWithValue(error);
    }
  }
);

const updateOwnClinicLocationProviderData = createAsyncThunk(
  'user/updateOwnClinicLocationProviderData',
  async (
    updateObj: {
      clinicLocationProviderId: string;
      updatedProperties: any;
    },
    { rejectWithValue }
  ) => {
    try {
      await ClinicLocationProviderService.updateClinicLocationProviderRelation(
        updateObj.clinicLocationProviderId,
        updateObj.updatedProperties
      );

      return updateObj;
    } catch (error) {
      rejectWithValue(error);
    }
  }
);

export { userInfo, updateOwnUserInfo, updateOwnClinicLocationProviderData };
